import { getTotalExperience } from "../services/utilService";
import { frontendExperienceData as experienceData } from "./experience.js";
import { frontendResumeSkills as skills } from "./skills.js";
import { profile, resumeFileName } from "./profile.js";

export { experienceData, skills };

export const professionalSummary = (
  <>
    Senior Software Engineer with {getTotalExperience(0.5)} building React and
    TypeScript frontends for production platforms, currently including agent
    creation and analytics UIs and a React + Tauri desktop app at Lua AI. Raised
    Lighthouse performance from 78 to 91 on a production aviation platform.
    Strengths: component architecture and design systems, TypeScript migrations,
    E2E test coverage, and client-side performance.
  </>
);

export const resumeDownloadOptions = {
  name: profile.name,
  fileName: resumeFileName(" - Frontend"),
};
